<template>
    <div>
        <apexchart type="line" height="300" width="100%" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { baseOptions, rgba } from "./theme";
import { moneyCompact, isNum } from "@/utils/format";

// Financial statement figures arrive in millions of USD.
const fromMillions = (v) => (isNum(v) ? moneyCompact(Number(v) * 1e6, 1) : "");

export default {
    name: "DebtChart",
    components: { apexchart: VueApexCharts },
    props: {
        DebtChartData: { type: Object, default: () => ({}) },
    },
    computed: {
        names() {
            return {
                revenue: this.$t("Revenue"),
                income: this.$t("Net Income"),
                margin: this.$t("Net Margin %"),
            };
        },
        series() {
            const d = this.DebtChartData || {};
            return [
                { name: this.names.revenue, type: "column", data: d.performanceDataRevenue || [] },
                { name: this.names.income, type: "column", data: d.performanceDataNetIncome || [] },
                { name: this.names.margin, type: "line", data: (d.performanceDataNetMargin || []).map(Number) },
            ];
        },
        chartOptions() {
            const base = baseOptions();
            return {
                ...base,
                chart: { ...base.chart, type: "line", stacked: false },
                colors: ["#00AA6F", "#0EA5E9", "#F59E0B"],
                stroke: { width: [0, 0, 2.5], curve: "smooth" },
                markers: { size: [0, 0, 4], strokeWidth: 0 },
                plotOptions: { bar: { columnWidth: "55%", borderRadius: 4 } },
                xaxis: {
                    categories: (this.DebtChartData || {}).performanceDataXAxis || [],
                    axisTicks: { show: false },
                    axisBorder: { color: rgba("line") },
                    tooltip: { enabled: false },
                },
                yaxis: [
                    { seriesName: this.names.revenue, labels: { formatter: fromMillions } },
                    { seriesName: this.names.revenue, show: false },
                    {
                        seriesName: this.names.margin,
                        opposite: true,
                        labels: { formatter: (v) => (isNum(v) ? `${Number(v).toFixed(0)}%` : "") },
                    },
                ],
                tooltip: {
                    ...base.tooltip,
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: (v, { seriesIndex }) =>
                            seriesIndex === 2 ? (isNum(v) ? `${Number(v).toFixed(2)}%` : "—") : fromMillions(v) || "—",
                    },
                },
            };
        },
    },
};
</script>
